export const FORMIK_VALIDATIONS = {
  REQUIRED: 'Required',
}
